const options = {
  5: "bg-teal-300/5",
  10: "bg-teal-300/10",
  25: "bg-teal-300/25",
  50: "bg-teal-300/50",
  75: "bg-teal-300/75",
  90: "bg-teal-300/90",
  100: "bg-teal-300",
};

const from = {
  5: "from-teal-300/5",
  10: "from-teal-300/10",
  25: "from-teal-300/25",
  50: "from-teal-300/50",
  75: "from-teal-300/75",
  90: "from-teal-300/90",
  100: "from-teal-300",
};

export default function getBackgroundTeal300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
